export default [
  {
    path: '/algoritmos/balanceamento/regras',
    name: 'ambience-balance-rules-index',
    component: () => import('./pages/RulesIndex'),
    meta: {
      title: 'Regras de balanceamento',
      icon: 'mdi-ruler-square-compass',
      breadcrumbs: [
        { text: 'Algoritmos', disabled: true, href: '/' },
        { text: 'Balanceamento', disabled: true, href: '/' },
        { text: 'Regras', disabled: true, href: '/' },
      ],
    },
  },
]
